import { useState } from 'react';
import {
  Alert,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { StyledButton } from 'components/Buttons';
import { LoaderFullScreen } from 'components/Loaders/LoaderFullScreen';
import { useTranslation } from 'react-i18next';
import * as S from '../../InvoiceLinesPanel.css';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
  isOwn: boolean;
};

export const PublishDialog = ({ open, onClose, onSubmit, isOwn }: Props) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(['misc']);

  const handleSubmit = async () => {
    setLoading(true);
    await onSubmit();
    setLoading(false);
    onClose();
  };

  return (
    <S.StyledDialog open={open} onClose={onClose}>
      <LoaderFullScreen loading={loading} />
      <DialogTitle>{t('button.publish', { ns: 'misc' })}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          {isOwn && (
            <Alert icon={false} severity='success' sx={{ mb: 1 }}>
              <DialogContentText>
                {t('modal.publishAlert', { ns: 'misc' })}
              </DialogContentText>
            </Alert>
          )}
          {t('modal.publishInvoiceBody', { ns: 'misc' })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <StyledButton $primary onClick={handleSubmit} disabled={loading}>
          {t('button.publish', { ns: 'misc' })}
        </StyledButton>
        <StyledButton onClick={onClose}>
          {t('button.cancel', { ns: 'misc' })}
        </StyledButton>
      </DialogActions>
    </S.StyledDialog>
  );
};
